module.exports = __webpack_public_path__ + "img/icon-mail.53f0d680.svg";